<template>
	<div>
		<base-info-card
			:title="title"
			:subtitle="subtitle"
			space="4"
			color="primary"
		/>

		<v-form ref="messageForm" v-model="formValid" lazy-validation>
			<v-text-field
				v-model="username"
				:counter="30"
				:rules="nameRules"
				label="Name"
				required
			></v-text-field>

			<v-text-field
				v-model="email"
				:rules="emailRules"
				label="E-mail"
				required
			></v-text-field>

			<v-textarea
				:counter="500"
				label="Message"
				:rules="messageRules"
				v-model="userMessage"
			></v-textarea>

			<v-btn
				:disabled="!formValid"
				color="secondary"
				class="mr-4"
				outlined
				x-large
				:loading="loading"
				@click="submit()"
			>
				Send Message
			</v-btn>
			<v-alert
				outlined
				class="mt-5"
				prominent
				text
				type="secondary"
				v-if="sent && success"
				>{{ successMessage }}</v-alert
			>
			<v-alert
				outlined
				class="mt-5"
				prominent
				text
				type="error"
				v-if="sent && failure"
				>{{ failureMessage }}</v-alert
			>
		</v-form>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'BaseContactForm',

	// Injected from the Vuetify Themeable mixin
	inject: ['theme'],

	props: {
		subtitle: String,
		title: {
			type: String,
			default: 'MAIL US YOUR MESSAGE',
		},
	},
	data: () => ({
		formValid: true,
		username: '',
		email: '',
		userMessage: '',
		successMessage:
			'Thank you for submitting your message.  We will get back to you shortly.',
		failureMessage:
			'Something went wrong.  Please reach out to us via phone or direct email.',
		loading: false,
		sent: false,
		success: false,
		failure: false,
		nameRules: [
			v => !!v || 'Name is required',
			v =>
				(v && v.length <= 30) ||
				'Name must be less than 10 characters',
		],

		emailRules: [
			v => !!v || 'E-mail is required',
			v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
		],

		messageRules: [
			v => !!v || 'Message is required',
			v =>
				(v && v.length <= 500) ||
				'Name must be less than 500 characters',
		],
	}),
	methods: {
		submit(e) {
			this.$refs.messageForm.validate()

			if (this.$refs.messageForm.validate()) {
				this.loading = true
				var currentUrl = window.location.origin
				var sendUrl = currentUrl + '/contact-form-mail.php'
				console.log(sendUrl)

				const formData = new FormData()
				formData.append('name', this.username)
				formData.append('email', this.email)
				formData.append('message', this.userMessage)

				axios.post(sendUrl, formData)
					.then(res => {
						this.loading = false
						this.sent = true
						this.success = true
					})
					.catch(res => {
						this.loading = false
						this.sent = true
						this.failure = true
					})
			}
		},
	},
}
</script>
